<template>
  <div
    id="how-it-works"
    class="w-full bg-sw_gray-50 md:px-16 md:py-10"
  >
    <p class="hidden text-xl font-bold md:text-2xl xl:text-2xl md:block md:mb-1 xl:mb-6">
      {{ tr('pages.sales.landing.howItWorks.title') }}
    </p>

    <div
      class="flex items-center justify-between px-4 py-3 text-lg font-bold md:hidden md:px-6 lg:px-8"
      @click="isOpen = !isOpen"
    >
      {{ tr('pages.sales.landing.howItWorks.title') }}

      <div class="flex-shrink-0 ml-4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.75 13.44" v-bind:svg-inline="''" :class="['h-4 w-4 transform', isOpen ? 'rotate-0' : '-rotate-90']" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.313 12.026L23.334.006l1.414 1.413-12.02 12.021z"/><path d="M.006 1.417L1.42.002l12.021 12.021-1.414 1.415z"/></svg>
      </div>
    </div>

    <div :class="['w-full flex-col py-6 px-4 md:pt-2 md:px-0 md:pb-0 md:flex-row md:flex md:space-x-12', isOpen ? '' : 'hidden']">
      <div class="flex items-center mb-6 md:w-1/3 md:mb-0">
        <div class="flex-shrink-0">
          <div class="mr-4 md:mr-4">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M24.364 16a1.454 1.454 0 00-2.91 0v.727h-.363V14.55v-.004a1.454 1.454 0 00-2.909 0v1.818h-.364v-2.545a1.455 1.455 0 00-2.909 0V16h-.363V7.636a1.455 1.455 0 00-2.91 0l-.005 13.088-.717.088-1.06-4.278a1.455 1.455 0 00-1.832-1.04c-.75.224-1.171 1.024-.982 1.784l1.571 6.3a7.273 7.273 0 007.057 5.513h1.423a7.273 7.273 0 007.273-7.273V16z" fill="#333"/><path d="M10.91 11.665v-1.4a3.412 3.412 0 01-1.237-2.629 3.422 3.422 0 013.418-3.418 3.422 3.422 0 013.418 3.418 3.412 3.412 0 01-1.236 2.63v1.399a4.586 4.586 0 002.4-4.029 4.587 4.587 0 00-4.582-4.582 4.587 4.587 0 00-4.582 4.582c0 1.737.972 3.252 2.4 4.029z" fill="#333"/></svg>
          </div>
        </div>
        <div class="flex-1 pt-1 mt-0.5 md:mt-0 md:pt-0">
          <p class="text-sm leading-snug xl:text-lg md:max-w-64">
            {{ tr('pages.sales.landing.howItWorks.one') }}
          </p>
        </div>
      </div>

      <div class="flex items-center mb-6 md:w-1/3 md:mb-0">
        <div class="flex-shrink-0">
          <div class="mr-4 md:mr-4">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M27.638 22.835V11.166l-7.769 5.83 7.77 5.84zM4.362 8.652v1.416L16 18.802l11.638-8.734V8.652H4.362zM4.362 11.166v11.67l7.769-5.84-7.77-5.83z" fill="#333"/><path d="M16 19.9l-3.14-2.35-7.718 5.798h21.706L19.13 17.55 16 19.9z" fill="#333"/></svg>
          </div>
        </div>
        <div class="flex-1 pt-1 mt-0.5 md:mt-0 md:pt-0">
          <p class="text-sm leading-snug xl:text-lg md:max-w-64">
            {{ tr('pages.sales.landing.howItWorks.two') }}
          </p>
        </div>
      </div>

      <div class="flex items-center md:w-1/3">
        <div class="flex-shrink-0">
          <div class="mr-4 md:mr-4">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M29.059 22.029a.133.133 0 00-.1-.046H3.04a.132.132 0 00-.13.152c.003.024.392 2.408 3.406 2.408h19.366c3.014 0 3.402-2.384 3.407-2.408a.134.134 0 00-.031-.106zm-11.04 1.68h-4.04v-.892h4.04v.891zM5.716 21.056h20.568c.295 0 .534-.24.534-.534V7.992a.534.534 0 00-.534-.535H5.716a.534.534 0 00-.534.534v12.53c0 .296.239.535.534.535zm1.336-11.73h17.896v9.86H7.052v-9.86z" fill="#333"/></svg>
          </div>
        </div>
        <div class="flex-1 pt-1 mt-0.5 md:mt-0 md:pt-0">
          <p class="text-sm leading-snug xl:text-lg md:max-w-64">
            {{ tr('pages.sales.landing.howItWorks.three') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HowItWorks from '~brand-components/base/sale-landing-page/how-it-works'

export default HowItWorks.extend()
</script>
